export default "__VITE_PUBLIC_ASSET__81cb7f01__"